import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import store from './vuex/store'
import Vuex from 'vuex'
import router from './router'
import { isAuth } from '@/utils'
// import '@/icons'
// import '@/permission'
import '../static/css/iconfont/1.0.0/index.css'
import '@/assets/icon/iconfont.css'
import '@/assets/scss/index.scss'

Vue.use(ElementUI);
Vue.use(Vuex);

Vue.prototype.isAuth = isAuth;     // 权限方法

new Vue({
    //el: '#app',
    //template: '<App/>',
    router,
    store,
    render: h => h(App)
}).$mount('#app');




// WEBPACK FOOTER //
// ./src/main.js